import { render, staticRenderFns } from "./PriceTagPrint.vue?vue&type=template&id=46823cf5&scoped=true"
import script from "./PriceTagPrint.vue?vue&type=script&lang=js"
export * from "./PriceTagPrint.vue?vue&type=script&lang=js"
import style0 from "./PriceTagPrint.vue?vue&type=style&index=0&id=46823cf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46823cf5",
  null
  
)

/* custom blocks */
import block0 from "./PriceTagPrint.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports